import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLoginLogo, getLoginLogoClear } from "../redux/home/actions";
import API_LIST from "../utils/apiList";
import CONFIG from "../utils/config";
import _ from "lodash";
import { isProd, setFavicon } from "../utils/AppUtils";
import Loader from "../components/Loader/Loader";

const LogoutPage = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const loginLogo = useSelector((state) => state.home.loginLogo);
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const [loginImage, setLoginImage] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");

  useEffect(() => {
    const domainArray = window.location.host.split(".");
    let subDomain = "";

    if (!domainArray[0].includes("localhost")) {
      //domainArray[0] !== CONFIG.SUB_DOMAIN_NAME &&
      subDomain = isProd()
        ? domainArray[0] + "." + domainArray[1]
        : domainArray[0];
      setIsLoadingLogin(true);
      dispatch(
        getLoginLogo({
          URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LOGIN_LOGO_URL}`,
          payload: {
            company_ref: subDomain,
            // email: localStorage.getItem('redirect_email')
          },
          isJSON: true,
          method: "post",
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(loginLogo)) {
      setIsLoadingLogin(false);
      if (
        loginLogo.status === "success" &&
        !_.isEmpty(loginLogo.payload?.data)
      ) {
        if (loginLogo.payload.data.login_image_url) {
          setLoginImage(loginLogo.payload.data.login_image_url);
        } else {
          setLoginImage("/images/finwell-img/banner.png");
        }
        setCompanyLogo(loginLogo.payload.data.company_logo);

        if (loginLogo.payload.data.company_name) {
          document.title = loginLogo.payload.data.company_name;
        }
        // if (loginLogo.payload.data.provider_image) {
        //   setFavicon(loginLogo.payload.data.provider_image);
        // }

        setTimeout(() => {
          dispatch(getLoginLogoClear());
        }, 2000);
      } else {
        setCompanyLogo("");
        setLoginImage("/images/finwell-img/banner.png");
        setTimeout(() => {
          dispatch(getLoginLogoClear());
        }, 2000);
      }
    }
  }, [loginLogo]);

  return (
    <>
      <Loader start={isLoadingLogin} />
      <div className="login-ary">
        <section className="login-sec ">
          <div className="login-container ">
            <div className="container-fluid">
              <div className="row bglogin">
                <div className="col-xl-7 col-lg-6 col-sm-12 col-12 image-login">
                  {
                    <img
                      className="img-fluid"
                      src={
                        loginImage
                          ? loginImage
                          : "/images/finwell-img/banner.png"
                        // loginImage
                      }
                      alt="home-scene-login"
                    />
                  }
                </div>
                <div className="col-xl-5 col-lg-6 col-sm-12 col-12 ttxt">
                  {
                    <div className="login-text mt-5 w-100">
                      <div
                        className="text-center lgo-box cursor-pointer"
                        onClick={() => navigate("/")}
                      >
                        <img
                          src={
                            companyLogo
                              ? companyLogo
                              : "/images/finwell-img/LogoEnvision.svg"
                          }
                          className="img-fluid"
                          width={200}
                          height={24}
                          alt="Finwell Envision logo"
                        />
                      </div>
                      {
                        <>
                          <h2 className="text-center logtitle">
                            {t("you_have_been_successfully_logged_out")}
                          </h2>
                          {false && (
                            <p className="ms-2-message text-center">
                              {t("Welcome back! Please enter your details.")}
                            </p>
                          )}
                        </>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LogoutPage;
